/* istanbul ignore file */

import dynamic from 'next/dynamic';

import type { TileCarouselSectionProps } from '../../../components/sections/TileCarouselSection';
import type { SectionRenderer } from '../../../types/Section';
import type { Transformer } from '../../../types/Transformer';
import { tiles } from './data';
import type { FakeTileCarouselContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<TileCarouselSectionProps> =
  dynamic<TileCarouselSectionProps>(() =>
    import('../../../components/sections/TileCarouselSection').then(
      (mod) => mod.TileCarouselSection,
    ),
  );

export const transformer: Transformer<
  FakeTileCarouselContentSection,
  TileCarouselSectionProps
> = ({}) => ({
  uid: 'fake-uid',
  props: {
    tiles,
    title: 'Shop by department',
    trackingTitle: 'tile carousel',
  },
});
